import { Enum, EnumType } from 'ts-jenum';
import _ from 'lodash';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faCircle as solidCircle } from '@fortawesome/pro-solid-svg-icons';
import { faCircle as regularCircle } from '@fortawesome/pro-regular-svg-icons';

@Enum<PresenceStatusType>('value')
export class PresenceStatusType extends EnumType<PresenceStatusType>() {
   static readonly UNKNOWN = new PresenceStatusType(
      'UNKNOWN',
      Number.MIN_VALUE,
      2999,
      regularCircle,
      'contact-state-unknown',
      'samwin.contact-status.types.presence_status_types.unknown',
      false
   );

   static readonly AVAILABLE = new PresenceStatusType(
      'AVAILABLE',
      3000,
      4499,
      solidCircle,
      'contact-state-available',
      'samwin.contact-status.types.presence_status_types.available'
   );

   static readonly INACTIVE = new PresenceStatusType(
      'INACTIVE',
      4500,
      5999,
      regularCircle,
      'contact-state-inactive',
      'samwin.contact-status.types.presence_status_types.inactive'
   );

   static readonly BUSY = new PresenceStatusType(
      'BUSY',
      6000,
      7499,
      solidCircle,
      'contact-state-busy',
      'samwin.contact-status.types.presence_status_types.busy'
   );

   static readonly IDLE_BUSY = new PresenceStatusType(
      'IDLE_BUSY',
      7500,
      8999,
      solidCircle,
      'contact-state-dle-busy',
      'samwin.contact-status.types.presence_status_types.busy_idle'
   );

   static readonly DO_NOT_DISTURB = new PresenceStatusType(
      'DO_NOT_DISTURB',
      9000,
      11999,
      solidCircle,
      'contact-state-do-not-disturb',
      'samwin.contact-status.types.presence_status_types.do_not_disturb'
   );

   static readonly BE_RIGHT_BACK = new PresenceStatusType(
      'BE_RIGHT_BACK',
      12000,
      14999,
      solidCircle,
      'contact-state-be-right-back',
      'samwin.contact-status.types.presence_status_types.be_right_back'
   );

   static readonly AWAY = new PresenceStatusType(
      'AWAY',
      15000,
      17999,
      solidCircle,
      'contact-state-away',
      'samwin.contact-status.types.presence_status_types.away'
   );

   static readonly OFFLINE = new PresenceStatusType(
      'OFFLINE',
      18000,
      Number.MAX_VALUE,
      solidCircle,
      'contact-state-offline',
      'samwin.contact-status.types.presence_status_types.offline'
   );

   private constructor(
      public value: string,
      public stateValueStart: number,
      public stateValueEnd: number,
      public statusIcon: IconDefinition,
      public styleClass: string,
      public translationKey: string,
      public displayTextDefault: boolean = true
   ) {
      super();
   }

   public static getPresenceStatusTypeByValue(stateValue: number) {
      const allValues = PresenceStatusType.values();
      const value = _(allValues)
         .filter((x) => x.stateValueStart <= stateValue && x.stateValueEnd >= stateValue)
         .head();
      return value ? value : PresenceStatusType.UNKNOWN;
   }
}
